// extracted by mini-css-extract-plugin
module.exports = {"Label":"FeedingsList_Label__12Mdr","List":"FeedingsList_List__U-a0q","ListItem":"FeedingsList_ListItem__23Cea"};